<div class="h-full overflow-hidden">
  @if (selectedCandidate) {
    <new-ui-candidate-edit
      class="block h-full w-full"
      [selectedCandidates]="[selectedCandidate]"
      [selectedCollectionId]="null"
      [selectedOrganizationId]="null"
      [selectedCollectionOrganizationId]="null"
      [sharings]="[]"
      [selectedSharing]="null"
      [isEditing]="false"
      [standardImmigrationCountry]="selectedCandidate.immigrationCountry"
      [isUneditableCollaboration]="false"
      [isReadOnlyCollaboration]="false"
      [isMultiEditMode]="false"
      [isFlexibleEditMode]="true"
      (closed)="close()"
    />
  }
</div>
